import { useMutation } from '@apollo/client'
import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { DotsIcon } from 'components/Icons/DotsIcon'
import { SwitchIcon } from 'components/Icons/SwitchIcon'
import Dropdown from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import List from 'components/v2/List'
import { IBusinessSiteActionsProps } from 'features/BusinessSites/views/Index/Actions/types'
import { ACTIVATE_BUSINESS_SITE } from 'features/BusinessSites/mutations-legacy'
import { SpinnerIcon } from 'components/Icons/SpinnerIcon'
import { PencilIcon } from 'components/Icons/PencilIcon'

export const BusinessSiteActions = ({ businessSite }: IBusinessSiteActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const [activateBusinessSite, { loading: activateBusinessSiteLoading }] = useMutation(ACTIVATE_BUSINESS_SITE, {
    update(cache) {
      cache.modify({
        id: cache.identify({
          __typename: 'BusinessSite',
          id: businessSite.id
        }),
        fields: {
          isActive: () => true
        }
      })
    }
  })

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const handleActivateBusinessSite = (): void => {
    if (!businessSite.isActive && !activateBusinessSiteLoading) {
      activateBusinessSite({
        variables: {
          id: businessSite.id
        }
      })
    }
  }

  return (
    <Dropdown.Wrapper noPadding noIndicator right onClickAway={(): void => setOpenDropdown(false)}>
      <IconButton onClick={toggleDropdown} icon={<DotsIcon />} noBorder smallPadding />
      <Dropdown.Content open={isOpenDropdown} noIndicator left noOverflow>
        <List.Container>
          <List.ItemLink href={`/business-sites/${businessSite.id}`}>
            <List.Icon>
              <PencilIcon />
            </List.Icon>
            <FormattedMessage id="dictionary.edit" defaultMessage="Edit" />
          </List.ItemLink>
          <List.Item onClick={handleActivateBusinessSite} disabled={businessSite.isActive}>
            <List.Icon>{activateBusinessSiteLoading ? <SpinnerIcon /> : <SwitchIcon />}</List.Icon>
            <FormattedMessage id="dictionary.activate" defaultMessage="Activate" />
          </List.Item>
        </List.Container>
      </Dropdown.Content>
    </Dropdown.Wrapper>
  )
}
